<template>
  <!-- 单元列表 -->
  <div
    v-if="isH5 && unitList.length"
    :class="{
      'h5-lesson-list': isH5,
    }"
  >
    <el-collapse v-model="activeNames">
      <el-collapse-item
        :class="{ 'have-lesson': unit.lesson_list && unit.lesson_list.length }"
        v-for="unit in unitList"
        :key="unit.id"
        :title="unit.unit_name"
        :name="unit.id"
      >
        <template slot="title">
          <div class="unit-name">
            {{ unit.unit_name }}
          </div>
        </template>
        <ul
          v-if="unit.lesson_list && unit.lesson_list.length"
          class="lesson-list"
        >
          <li v-for="(lesson, index) in unit.lesson_list" :key="lesson.id">
            <!-- 直播课 -->
            <div
              v-if="lesson.lesson_type === 2"
              class="lesson-wrap"
              @click="handleLiveClick(lesson)"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ index + 1 }}</span>
                  <span
                    v-if="lesson.canTrial && !isRegistered"
                    class="lesson-type-tag can-trial"
                    >试学</span
                  >
                  <span
                    v-else-if="lesson.roomStatus === 2"
                    class="lesson-type-tag living"
                  >
                    <img
                      src="../../../assets/images/product-details/live.gif"
                      alt=""
                  /></span>
                  <span v-else class="lesson-type-tag">{{
                    [1].includes(lesson.liveStatus) ? "视频" : "直播"
                  }}</span>
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span class="duration">
                    {{
                      moment(lesson.live_start_time * 1000).format(
                        "YYYY.MM.DD HH:mm"
                      )
                    }}-{{ moment(lesson.live_end_time * 1000).format("HH:mm") }}
                  </span>
                  <span class="separate"></span>
                  <p class="teacher">
                    {{ lesson.org_nickname }}
                  </p>
                </div>
              </div>
            </div>
            <!-- 点播课 -->
            <div
              v-else-if="lesson.lesson_type === 1"
              @click="goReplay(lesson)"
              class="lesson-wrap"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ index + 1 }}</span>
                  <span
                    v-if="lesson.canTrial && !isRegistered"
                    class="lesson-type-tag can-trial"
                    >试学</span
                  >
                  <span v-else class="lesson-type-tag saas-demand-color"
                    >视频</span
                  >
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span class="duration">
                    {{ handleDuration(lesson.duration) }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 音频课 -->
            <div
              v-else-if="lesson.lesson_type === 5"
              @click="goReplay(lesson)"
              class="lesson-wrap"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ index + 1 }}</span>
                  <span
                    v-if="lesson.canTrial && !isRegistered"
                    class="lesson-type-tag can-trial"
                    >试学</span
                  >
                  <span v-else class="lesson-type-tag" style="background-color: #7C3AED; color: #fff;"
                    >音频</span
                  >
                  <span class="lesson-name">{{ lesson.lesson_name }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span class="duration">
                    {{ handleDuration(lesson.duration) }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 作业 -->
            <div
              v-else
              class="lesson-wrap"
              @click="goHomeWorkPage(lesson.work_info)"
              :class="{ 'show-lock': showLock(lesson) }"
            >
              <div class="lesson-info-wrap">
                <p class="lesson-name-wrap">
                  <span class="lesson-index">{{ index + 1 }}</span>
                  <span class="lesson-type-tag saas-homework-color">作业</span>
                  <span class="lesson-name">{{
                    lesson.work_info.homework_name
                  }}</span>
                </p>
                <div class="lesson-item-bottom">
                  <span v-if="lesson.work_end_time" class="duration"
                    >限{{
                      moment(lesson.work_end_time * 1000).format("YYYY.MM.DD")
                    }}前完成</span
                  >
                  <span v-else class="duration">不限时</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import LessonList from "./mixins/lesson-list.js";
export default {
  mixins: [LessonList],
};
</script>

<style lang="scss" scoped>
$lesson-index-width: 0.53rem;
// 适配
.h5-lesson-list {
  padding: 0 0.32rem;
  // 课程类型标签
  .lesson-type-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    // height: 0.48rem;
    border-radius: 0.11rem;
    border: 0.01rem solid #efefef;
    font-weight: 400;
    font-size: 0.29rem;
    color: #747573;
    line-height: 1;
    padding: 0.1rem 0.11rem 0.09rem;
    background: #fff;
    width: auto;
    &.can-trial {
      color: #f03349;
      border: 0.01rem solid #feadb7;
    }
    &.living {
      width: 0.8rem;
      border: 0.01rem solid #b8e7dd;
      padding-top: 0.08rem;
      padding-bottom: 0.08rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__header {
    background: #f7f8f9;
    border-radius: 0.27rem;
    padding: 0.32rem;
    border: none;
    .unit-name {
      white-space: nowrap;
      line-break: anywhere;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90%;
      max-width: 90%;
      font-weight: 500;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
    }
    i {
      color: #0d1400;
      font-weight: bold;
      font-size: 0.27rem;
    }
  }
  ::v-deep .el-collapse-item__content {
    padding-bottom: 0;
  }
  ::v-deep .el-collapse-item__wrap {
    border: none;
  }
  ::v-deep .el-collapse-item {
    margin-bottom: 0.32rem;
    &.is-active.have-lesson {
      margin-bottom: 0;
    }
  }
  .lesson-list > li {
    padding: 0 0.05rem;
  }
  .lesson-wrap {
    position: relative;
    padding: 0.32rem 0;
    border-bottom: 0.03rem solid #efefef;
    &.show-lock::after {
      position: absolute;
      content: " ";
      right: 0;
      bottom: 0.32rem;
      display: block;
      width: 0.4rem;
      height: 0.4rem;
      background: url("../../../assets/images/product-details/lock.png");
      background-size: 100% 100%;
    }
    .lesson-name-wrap {
      display: flex;
      align-items: flex-end;
      margin-bottom: 0.19rem;
      .lesson-index {
        font-size: 0.32rem;
        color: #858687;
        line-height: 0.44rem;
        width: $lesson-index-width;
      }
      .lesson-name {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 0.13rem;
        font-weight: 400;
        font-size: 0.37rem;
        color: #0d1400;
        line-height: 0.48rem;
        line-break: anywhere;
      }
    }
    .lesson-item-bottom {
      display: flex;
      align-items: center;
      color: $plain-text-color;
      font-weight: 400;
      font-size: 0.3rem;
      line-height: 0.43rem;
      padding-left: $lesson-index-width;
      .separate {
        width: 0.01rem;
        height: 0.16rem;
        background: #efefef;
        border-radius: 0.03rem;
        margin: 0 0.13rem;
      }
      .teacher {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .lesson-list > li:last-child {
    .lesson-wrap {
      border-bottom: none;
    }
  }
}
::v-deep .el-collapse-item__arrow.el-icon-arrow-right.is-active {
  transform: rotate(-90deg);
}
::v-deep .el-collapse-item__arrow.el-icon-arrow-right {
  transform: rotate(90deg);
}
</style>
